'use client';

import { useDeviceStore } from '@/store/about/deviceStore';

export default function ClientInfo() {
  const clientInfo = useDeviceStore((state) => state.clientInfo);

  return <>{clientInfo}</>;
}
